function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipsisThin = function SvgEllipsisThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  }));
};
export default SvgEllipsisThin;